import React from 'react'

const BriefCaseIcon = props => (
  <svg viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.85476 2.55246V3.10575H7.08395C7.46438 3.10575 7.77563 3.417 7.77563 3.79743V5.87249C7.77563 6.25291 7.46438 6.56417 7.08395 6.56417H1.55046C1.17004 6.56417 0.858777 6.25291 0.858777 5.87249V3.79743C0.858777 3.417 1.17004 3.10575 1.55046 3.10575H1.7797V2.55246C1.7797 2.10784 1.93445 1.62076 2.31415 1.24107C2.69384 0.861375 3.18092 0.706619 3.62554 0.706619H5.00891C5.45354 0.706619 5.94062 0.861375 6.32031 1.24107C6.7 1.62076 6.85476 2.10784 6.85476 2.55246ZM4.31721 5.87249C4.1097 5.87249 3.97136 5.73415 3.97136 5.52664C3.97136 5.31914 4.1097 5.1808 4.31721 5.1808C4.52471 5.1808 4.66305 5.31914 4.66305 5.52664C4.66305 5.73415 4.52471 5.87249 4.31721 5.87249ZM1.55045 6.91001H7.08394C7.46436 6.91001 7.77562 6.59875 7.77562 6.21832V7.60169C7.77562 7.98212 7.46436 8.29338 7.08394 8.29338H1.55045C1.17002 8.29338 0.858765 7.98212 0.858765 7.60169V6.21832C0.858765 6.59875 1.17002 6.91001 1.55045 6.91001Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="4.3172"
        y1="0.706619"
        x2="-0.688366"
        y2="9.33929"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default BriefCaseIcon
